import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from "./theme/theme";
import { Provider } from "react-redux";
import { store } from "@/store";
import { IconContext } from "react-icons/lib";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
    <Provider store={store}>
    <Router>
    <ThemeProvider theme={theme}>
    <IconContext.Provider value={{ color: "#fff" }}>
        <App />
    </IconContext.Provider>
    </ThemeProvider>
    </Router>
    </Provider>
    </React.StrictMode>
);
